export default function PillWithActionButton({
  label,
  buttonIcon = "#ui-icon-circle-close-outline",
  action,
}) {
  return (
    <>
      <div className="px-2 gap-2 ui-badge-pill normal-case bg-ui-gray-light hover:bg-ui-red-light hover:text-ui-red">
        <span className="block text-xs font-medium">{label}</span>
        <button onClick={() => action()}>
          <svg
            className="ui-icon w-4 h-4"
            focusable="false"
            aria-hidden="true"
            role="presentation"
          >
            <use href={buttonIcon}></use>
          </svg>
        </button>
      </div>
    </>
  );
}
